import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/iconite/home.png'
import _imports_1 from '@/assets/iconite/search.png'
import _imports_2 from '@/assets/menu_icons/Date_companie.png'
import _imports_3 from '@/assets/menu_icons/Utilizatori.png'
import _imports_4 from '@/assets/menu_icons/Editare_profil.png'
import _imports_5 from '@/assets/iconite/locatie.png'
import _imports_6 from '@/assets/iconite/mesaj.png'
import _imports_7 from '@/assets/iconite/login.png'
import _imports_8 from '@/assets/menu_icons/Iesire.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"position":"relative","zoom":"0.7","width":"24px","height":"24px"}
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"position":"relative","zoom":"0.7","width":"24px","height":"24px"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  style: {"width":"24px","height":"24px","margin-right":"4px"}
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  style: {"position":"relative","zoom":"0.8","width":"28px","height":"24px"}
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  style: {"position":"relative","zoom":"0.8","width":"24px","height":"24px"}
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  style: {"position":"relative","zoom":"0.8","width":"24px","height":"24px"}
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  style: {"position":"relative","zoom":"0.7","width":"24px","height":"28px"}
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  style: {"position":"relative","width":"24px","height":"24px","zoom":"0.8"}
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  style: {"position":"relative","zoom":"0.7","width":"24px","height":"24px"}
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  style: {"position":"relative","zoom":"0.7","width":"24px","height":"24px"}
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Log out ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createVNode(_component_q_item, {
      clickable: "",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToView('Dashboard')))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_item_section, { avatar: "" }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createVNode(_component_q_item_section, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_label, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('message.main_page')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512), [
      [_directive_ripple]
    ]),
    _withDirectives(_createVNode(_component_q_item, {
      clickable: "",
      onClick: _ctx.onGoToBrowseCategories
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_item_section, { avatar: "" }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_q_item_section, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_label, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('message.search_items')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onClick"]), [
      [_directive_ripple]
    ]),
    (_ctx.user.tip == '1' || _ctx.user.tip == '2' || _ctx.user.tip == '3')
      ? (_openBlock(), _createBlock(_component_q_separator, {
          key: 0,
          inset: ""
        }))
      : _createCommentVNode("", true),
    (_ctx.user.tip == '1' || _ctx.user.tip == '2' || _ctx.user.tip == '3')
      ? (_openBlock(), _createBlock(_component_q_item_label, {
          key: 1,
          header: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('message.manage')), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.user.tip == '1')
      ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          key: 2,
          clickable: "",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToView('AdminCompanies')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { avatar: "" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('message.companies')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512)), [
          [_directive_ripple]
        ])
      : _createCommentVNode("", true),
    (_ctx.user.tip == '1')
      ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          key: 3,
          clickable: "",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToView('AdminUsers')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { avatar: "" }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('message.users')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512)), [
          [_directive_ripple]
        ])
      : _createCommentVNode("", true),
    (_ctx.user.tip == '1')
      ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          key: 4,
          clickable: "",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToView('AdminCategory')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { avatar: "" }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('message.categories')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512)), [
          [_directive_ripple]
        ])
      : _createCommentVNode("", true),
    (_ctx.user.tip == '1')
      ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          key: 5,
          clickable: "",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToView('AdminArticles')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { avatar: "" }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('message.items')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512)), [
          [_directive_ripple]
        ])
      : _createCommentVNode("", true),
    (_ctx.user.tip == '1' || _ctx.user.tip == '2' || _ctx.user.tip == '3')
      ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          key: 6,
          clickable: "",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goToView('BackOffice')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { avatar: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  color: "#273233",
                  name: "meeting_room"
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('message.back_office')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512)), [
          [_directive_ripple]
        ])
      : _createCommentVNode("", true),
    (_ctx.user.tip == '1' || _ctx.user.tip == '2' || _ctx.user.tip == '3')
      ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          key: 7,
          clickable: "",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goToView('AdminAdreseLivrare')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { avatar: "" }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('message.admin_delivery_addresses')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512)), [
          [_directive_ripple]
        ])
      : _createCommentVNode("", true),
    (_ctx.user.tip == '1')
      ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          key: 8,
          clickable: "",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goToView('AdminSendNotification')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { avatar: "" }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('message.send_notification')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512)), [
          [_directive_ripple]
        ])
      : _createCommentVNode("", true),
    (_ctx.user.tip == '1')
      ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          key: 9,
          clickable: "",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.goToView('AdminReports')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { avatar: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  color: "#273233",
                  name: "summarize"
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('message.reports')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512)), [
          [_directive_ripple]
        ])
      : _createCommentVNode("", true),
    _createVNode(_component_q_separator, { inset: "" }),
    _withDirectives(_createVNode(_component_q_item, {
      clickable: "",
      onClick: _ctx.goToMyProfile
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_item_section, { avatar: "" }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }),
        _createVNode(_component_q_item_section, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_label, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('message.my_profile')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onClick"]), [
      [_directive_ripple]
    ]),
    _withDirectives(_createVNode(_component_q_item, {
      clickable: "",
      onClick: _ctx.logout
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_item_section, { avatar: "" }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }),
        _createVNode(_component_q_item_section, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_label, null, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onClick"]), [
      [_directive_ripple]
    ])
  ]))
}